module.exports = __webpack_public_path__ + "static/media/happy-burger.038ee399.png";